import { isEmpty, flatten } from 'lodash-es'
// 单独一行的类型
const rowFieldType = [
  'media',
  'attachment',
  'gis',
  'area',
  'standard',
  'geolocation',
  'ref',
]

const lastFiledType = ['gis', 'geolocation']
// editableFields 需判断在不在已配置好的数据中
export const dealLayouts = (
  fields,
  editableFields,
  data = {},
  layouts = {}
) => {
  // 处理地图类型
  const preFields = fields.filter((v) => !lastFiledType.includes(v.type))
  const lastFileds = fields.filter((v) => lastFiledType.includes(v.type))
  const finalFields = [...preFields, ...lastFileds]

  const _layout = { ...layouts }
  const { children } = _layout
  const rowFields = finalFields.filter(
    (v) =>
      v &&
      (rowFieldType.includes(v.type) ||
        (v.type === 'text' &&
          data &&
          data[v.slug] &&
          data[v.slug].length > 300)) &&
      !v.hidden
  )
  const colFields = finalFields.filter(
    (v) =>
      v &&
      !rowFieldType.includes(v.type) &&
      !(
        v.type === 'text' &&
        data &&
        data[v.slug] &&
        data[v.slug].length > 300
      ) &&
      !v.hidden
  )

  if (isEmpty(layouts)) {
    const arr = [
      {
        fields: {
          cols: 3,
          children: colFields.map((v) => {
            return { slug: v.slug, title: v.title }
          }),
        },
      },
      {
        fields: {
          cols: 1,
          children: rowFields
            .filter((v) => v.type !== 'geolocation')
            .map((v) => {
              return { slug: v.slug, title: v.title }
            }),
        },
      },
      {
        fields: {
          cols: 3,
          children: rowFields
            .filter((v) => v.type === 'geolocation')
            .map((v) => {
              return { slug: v.slug, title: v.title }
            }),
        },
      },
    ]

    return {
      ..._layout,
      children: [
        {
          content: {
            type: 'groups',
            children: arr,
          },
        },
      ],
    }
  }
  if (!editableFields || editableFields.length === 0) {
    return {
      ..._layout,
      children,
    }
  }

  const group = (children.length && children[0]) || {}
  const { content = {} } = group

  const arr = (editableFields || [])
    .filter((v) => {
      const _arr = flatten(
        (content.children || []).map((f) => f.fields.children || [])
      ).map((f) => f.slug)

      return !_arr.includes(v.slug)
    })
    .map((v) => {
      return { slug: v.slug, title: v.title }
    })

  const childs = [
    ...content.children,
    {
      fields: {
        cols: 4,
        // rows: arr % 4 ? arr / 4 + 1 : arr / 4,
        children: arr,
      },
    },
  ]

  return {
    ..._layout,
    children: [{ content: { ...content, children: childs } }],
  }
}

export const dealLayoutSlugs = (layouts = {}) => {
  const { children = [] } = layouts
  return flatten(
    children.map((item) => {
      const { content = {} } = item
      return flatten(
        (content.children || []).map((v) => {
          return ((v.fields && v.fields.children) || []).map((f) => f.slug)
        })
      )
    })
  )
}

export const dealRefTypeFilter = (layouts = {}) => {
  const obj = {}
  const { children = [] } = layouts

  children.forEach((item) => {
    const { content = {} } = item
    if (content.children && content.children.length) {
      content.children.forEach((v) => {
        if (v.fields && v.fields.children) {
          v.fields.children.forEach((f) => {
            obj[f.slug] = f.filters
          })
        }
      })
    }
  })
  return obj
}
